import React from "react";
import { styled } from "styled-components";
import { MdAlternateEmail } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { HiOutlineMailOpen } from "react-icons/hi";
import { AiFillGithub, AiFillLinkedin, AiOutlineArrowUp } from "react-icons/ai";
import { FiMail, FiPhoneCall } from "react-icons/fi";
import { TbBrandLeetcode } from "react-icons/tb";
import { Slide, Zoom } from "react-awesome-reveal";
const Footer = () => {
  const scrollUp = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <Container id="footer">
      <Profile>
        <h1>Portfolio</h1>
        <div className="address">
          <h1>Address:</h1>

          <Slide direction="left" triggerOnce="true">
            {" "}
            <p> NOIDA, Uttar Pradesh, INDIA</p>{" "}
          </Slide>
        </div>
        <div className="links">
          <h1>Contact me:</h1>
          <div>
            <span>
              <FiPhoneCall />
            </span>
            <Slide direction="left" triggerOnce="true">
              <a href="tel:+91">+91-9915339557</a>
            </Slide>
          </div>
          <div>
            <span>
              <HiOutlineMailOpen />
            </span>
            <Slide direction="left">
              {" "}
              <a href="mailto:kumarchandu9557@gmail.com">
                kumarchandu9557@gmail.com
              </a>
            </Slide>
          </div>
        </div>
        <div className="profile">
          <h1>Check my profiles</h1>

          <div className="icons">
            <Zoom>
              <span>
                <a
                  href="https://github.com/chandan9557"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AiFillGithub />
                </a>
              </span>
            </Zoom>
            <Zoom>
              <span>
                <a
                  href="https://www.linkedin.com/in/chandan-kr-sahani-35a753234/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AiFillLinkedin />
                </a>
              </span>
            </Zoom>
            <Zoom>
              <span>
                <a
                  href="https://www.linkedin.com/in/chandan-kr-sahani-35a753234/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <TbBrandLeetcode />
                </a>
              </span>
            </Zoom>
          </div>
        </div>
        <ArrowUp onClick={scrollUp}>
          <AiOutlineArrowUp />
        </ArrowUp>
      </Profile>

      <Form>
        <Slide direction="right" triggerOnce="once">
          <form
            action="mailto:kumarchandu9557@gmail.com"
            method="post"
            enctype="text/plain"
          >
            <div className="name">
              <span>
                <CgProfile />
              </span>
              <input type="text" name="name" placeholder="Enter your name" />
            </div>
            <div className="email">
              <span>
                <MdAlternateEmail />
              </span>
              <input type="email" name="mail" placeholder="Enter your Email" />
            </div>
            <div className="message">
              <span className="messageIcon">
                <FiMail />
              </span>
              <textarea cols="30" type="text" rows="10" placeholder="Message" />
            </div>
            <button type="submit" value="Send">
              Send
            </button>
          </form>
        </Slide>
      </Form>
    </Container>
  );
};

export default Footer;

const Container = styled.div`
  margin-top: 2rem;
  position: relative;
  padding: 2rem 0;
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  @media (max-width: 840px) {
    width: 90%;
  }
  @media (max-width: 650px) {
    flex-direction: column;
    gap: 3rem;
  }
`;
const Profile = styled.div`
  flex: 1;
  .address {
    padding: 1rem 0;
    h1 {
      font-size: 1.2rem;
    }
    p {
      width: 60%;
      padding-top: 0.5rem;
      @media (max-width: 650px) {
        width: 100%;
      }
    }
  }
  .links {
    h1 {
      font-size: 1.2rem;
      margin-bottom: 0.5rem;
    }
    div {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      a {
        text-decoration: none;
        color: lightgrey;

        &:hover {
          color: orange;
        }
        @media (max-width: 294px) {
          font-size: 0.7rem;
        }
      }
    }
  }
  .profile {
    h1 {
      font-size: 1.2rem;
      padding: 1rem 0;
    }
    .icons {
      display: flex;
      align-items: center;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000;
        width: 2rem;
        height: 2rem;
        margin-right: 0.5rem;
        border-radius: 50px;
        &:hover {
          background-color: orange;
        }
        a {
          margin-top: 0.2rem;
          color: #fff;
        }
      }
    }
  }
`;
const ArrowUp = styled.div`
  width: 2rem;
  height: 2rem;
  background-color: #01be96;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 700;
  margin-top: 2rem;
`;
const Form = styled.div`
  flex: 1;
  h1 {
    font-size: 1.3rem;
    padding-bottom: 0.7rem;
  }

  form {
    background-color: #191923;
    padding: 0.8rem;
    border-radius: 5px;
    .name,
    .email,
    .message {
      display: flex;
      border: 1px solid gray;
      margin-bottom: 0.5rem;
      input,
      textarea {
        width: 100%;
        border: none;
        outline: none;
        color: #fff;
        background-color: transparent;
        padding: 1rem 0.5rem;
      }
      span {
        background-color: #3e3e3e;
        width: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .messageIcon {
        align-items: flex-start;
        padding-top: 0.7rem;
      }
    }
    button {
      width: 5rem;
      height: 1.8rem;
      background-color: #01be96;
      border-radius: 5px;
      border: none;
      filter: drop-shadow(0px 4px 5px #01be9551);
      cursor: pointer;
      &:hover {
        background-color: #4e4e4e;
        filter: drop-shadow(0px 3px 5px #bde0d9e8);
        border: solid 1px #bde0d9e8;
      }
    }
  }
`;
